/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Too_Many_ClubsInputs */

const en_us2_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've reached the club limit. Leave one to join another.`)
};

const pt_br2_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você chegou ao limite de clubes. Saia de um para entrar em outro.`)
};

const es_419_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llegaste al límite de clubes. Sal de uno para unirte a otro.`)
};

const pt_pt2_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chegaste ao limite de clubes. Sai de um para entrares noutro.`)
};

const fr_fr2_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as atteint la limite de clubs. Quittes-en un pour en rejoindre un autre.`)
};

const de_de2_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast das Club-Limit erreicht. Verlass einen, um einem anderen beizutreten.`)
};

const it_it2_club_too_many_clubs = /** @type {(inputs: Club_Too_Many_ClubsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai raggiunto il limite di club. Lasciane uno per entrare in un altro.`)
};

/**
* | output |
* | --- |
* | "You've reached the club limit. Leave one to join another." |
*
* @param {Club_Too_Many_ClubsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_too_many_clubs = /** @type {((inputs?: Club_Too_Many_ClubsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Too_Many_ClubsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_too_many_clubs(inputs)
	if (locale === "es-419") return es_419_club_too_many_clubs(inputs)
	if (locale === "pt-PT") return pt_pt2_club_too_many_clubs(inputs)
	if (locale === "fr-FR") return fr_fr2_club_too_many_clubs(inputs)
	if (locale === "de-DE") return de_de2_club_too_many_clubs(inputs)
	if (locale === "it-IT") return it_it2_club_too_many_clubs(inputs)
	return en_us2_club_too_many_clubs(inputs)
});
export { club_too_many_clubs as "club.too_many_clubs" }